module.exports = __webpack_public_path__ + "img/Pho.7438e23c.svg";